import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros = 0;
  constructor() {}

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data);
    //let getFirmas = this.getFirmas(mainData.processedDataMesero,mainData.porcentaje)
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "landscape",
      content: [
        //header
        {
          columns: [
            {
              width: "25%",
              text: "",
            },
            {
              width: "50%",
              alignment: "center",
              bold: true,
              text: [mainData.TITLE + "\n"],
            },
            {
              width: "25%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora: " + mainData.HG + "\n",
              ],
            },
          ],
          columnGap: 10,
        },
        {
          columns: [
            {
              width: "100%",
              table: {
                widths: [250, 100, 100, 200, 100],
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let rows = [
      [
        {
          text: "Movimientos",
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Cantidad", border: [true, true, true, true], fontSize: 12 },
        {
          text: "Cantidad MXN",
          border: [true, true, true, true],
          fontSize: 12,
        },
        {
          text: "Saldo Desp. Mov.",
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Tipo", border: [true, true, true, true], fontSize: 12 },
      ],
    ];
    data.forEach((cliente) => {
      let rowToAdd = [
        {
          text: cliente.NombreCompleto + " "+cliente.Apodo + " Saldo: $" +pgsHelper.formatNumber(cliente.Monedero.Saldo),
          border: [true, true, true, true],
          fontSize: 12,
          colSpan: 5,
          fillColor: "#CCE3F4",
        },
      ];
      rows.push(rowToAdd);
      cliente.MovimientosMonedero.forEach((mov)=>{
        let movToAdd = [
            { text: [
                mov.Descripcion + "\n",
                "Fecha: " + mov.Fecha + "\n",
                mov?._m?.og
              ] , border: [true, true, false, false], fontSize: 10 },
            { text: pgsHelper.formatNumber(mov.Cantidad), border: [true, true, false, false], fontSize: 10 },
            { text: pgsHelper.formatNumber(mov.Cantidad) , border: [true, true, false, false], fontSize: 10 },
            { text:  [
                "Saldo antes de mov:"+pgsHelper.formatNumber(mov.SaldoAnterior) + "\n",
                "Saldo despues de mov: " + pgsHelper.formatNumber(mov.SaldoPosterior) + "\n",
              ] , border: [true, true, false, false], fontSize: 10 },
            { text: mov._Op, border: [true, true, false, false], fontSize: 10 },
           
          ]
          rows.push(movToAdd)
      })

      

    });
    /*groupedData.forEach((venta)=>{
      let rowToAdd = [];
      if(!venta.header & !venta.footer){
        let concierge =  (venta.Concierge != "")?" Concierge:"+venta.Concierge:""
        rowToAdd = [
          { text: venta.Folio, border: [true, true, false, false], fontSize: 10 },
          { text: venta.playerNombre, border: [true, true, false, false], fontSize: 10 },
          { text: venta.totalAccount , border: [true, true, false, false], fontSize: 10 },
          { text: venta.date_format, border: [true, true, false, false], fontSize: 10 },
          { text: venta.time_format, border: [true, true, false, false], fontSize: 10 },
          { text: venta.Estatus, border: [true, true, false, false], fontSize: 10 },
          { text: venta.FolioVenta, border: [true, true, false, false], fontSize: 10 },
          { text: venta.Comision.C + " "+ venta.Comision.M, border: [true, true, false, false], fontSize: 10 },
          { text: venta.NombreHotel + concierge, border: [true, true, false, false], fontSize: 10 },
          { text: venta.Precio, border: [true, true, false, false], fontSize: 10 },
          { text: venta.Moneda, border: [true, true, true, false], fontSize: 10 },
        ]
        times.push(
            rowToAdd
        )
      }
      if(venta.header){
        rowToAdd = [
          { text: venta.text, border: [true, true, true, true], fontSize: 12,colSpan: 11,fillColor:"#CCE3F4" },
        ]
        times.push(
            rowToAdd
          )
      }    
      if(venta.footer){
        rowToAdd = [
          { text: venta.text, border: [true, true, true, true], fontSize: 10,fillColor:"#DCDCDC",alignment: 'left' },
          { text: "", border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'left' },
          {text: venta.totalCantidad, border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'left' },
          {text: "",colSpan:8, border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'left' },
          {text: "", border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'left' },
          {text: "", border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'left' },
          {text: "", border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'left' },
          {text: "", border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'left' },
          {text: "", border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'left' },
          {text: "", border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'left' },
          { text: "", bold: true, border: [true, true, true, true], fontSize: 10 ,alignment: 'right',fillColor:"#DCDCDC"},
          
        ]
        times.push(
            rowToAdd
          )
      }
    })*/

    return rows;
  }

}
